export const unique = <T>(array: T[] = []) => {
  return array.filter((item, index) => array.indexOf(item) === index);
};

export const toRecord = <T extends { id: any }>(
  collection: Array<T>,
  ...concatCollections: Array<Record<T['id'], T>>
): Record<T['id'], T> => {
  return Object.assign({}, ...collection.map((item) => ({ [item.id]: item })), ...(concatCollections || []));
};
